/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/operators/like.json`.

import type { OperatorDefinition } from '../../definition_types';

/**
 * Use `LIKE` to filter data based on string patterns using wildcards. `LIKE`
 * usually acts on a field placed on the left-hand side of the operator, but it can
 * also act on a constant (literal) expression. The right-hand side of the operator
 * represents the pattern, which can be a string literal, a query parameter, or any
 * constant expression such as a call to `CONCAT` or `TO_LOWER`.
 *
 * The following wildcard characters are supported:
 *
 * * `*` matches zero or more characters.
 * * `?` matches one character.
 *
 * @example
 * FROM employees
 * | WHERE first_name LIKE """?b*"""
 * | KEEP first_name, last_name
 */
const definition: OperatorDefinition = {
  operator: 'LIKE',
  name: 'like',
  signatures: [
    {
      params: [
        {
          name: 'str',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'pattern',
          type: 'keyword',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'str',
          type: 'text',
          optional: false,
        },
        {
          name: 'pattern',
          type: 'keyword',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
